import { useQuery } from "@tanstack/react-query";
import { fetchPupilsWithCategories } from "api/pupils/fetchPupilsWithRiskGroups";
import { useMemo } from "react";

export function useFetchPupilsByCategory(categoryId) {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["pupils/with-categories"],
        queryFn: fetchPupilsWithCategories,
    });

    const pupils = useMemo(() => {
        if (!data || !categoryId) return [];
        
        return data.filter((pupil) => 
            pupil.categories.some((cat) => cat._id === categoryId)
        );
    }, [data, categoryId]);

    return {
        pupils,
        pupilsError: error,
        pupilsIsLoading: isLoading,
        refetchPupils: refetch,
    };
}
